<!-- 巡检维保完成率 -->
<template>
  <div class="inspection-maintenance-completed">
    <!-- <div class="completed-header">
      <div class="header-title">{{ title }}</div>
    </div> -->
    
    <div class="chart-container">
      <div ref="chartRef" class="chart"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { postAction } from '@/api/manage'

export default {
  name: 'InspectionMaintenanceCompleted',
  data() {
    return {
      title: this.$t('巡检保养完成率'),
      url: {
        LargeScreenSumInspectionTypeFinishByTime: "/jeecg-engineering/inspection/inspectionTask/LargeScreenSumInspectionTypeFinishByTime"
      },
      chart: null
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.disposeChart()
  },
  methods: {
    init() {
      this.getData()
    },
    getData() {
      postAction(this.url.LargeScreenSumInspectionTypeFinishByTime, { queryType: 3 }).then(res => {
        if (res.success) {
          const data = res.result
          this.setOption(data.xdata, data.ydata)
        }
      }).catch(() => {
        this.loadMockData()
      })
    },
    loadMockData() {
      const mockData = {
        xdata: ['1月', '2月', '3月', '4月', '5月', '6月'],
        ydata: [
          {
            inspectionTaskSum: 45,
            maintenanceTaskSum: 32,
            finishRate: 85.2
          },
          {
            inspectionTaskSum: 52,
            maintenanceTaskSum: 38,
            finishRate: 87.1
          },
          {
            inspectionTaskSum: 48,
            maintenanceTaskSum: 35,
            finishRate: 89.3
          }
        ]
      }
      this.setOption(mockData.xdata, mockData.ydata)
    },
    setOption(xData, yData) {
      let y1 = [];
      let y2 = [];
      let y3 = [];
      yData.map(item => {
        y1.push(item.inspectionTaskSum);
        y2.push(item.maintenanceTaskSum);
        y3.push(item.finishRate);
      });
      
      const option = {
        color: ['#0394FF', '#50E3C2', '#F6BB2F'],
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 8,
          textStyle: {
            color: '#CEE2FF',
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#019AF3'
            }
          }
        },
        legend: {
          type: 'scroll',
          data: [this.$t('实际巡检'), this.$t('实际保养'), this.$t('综合完结率(%)')],
          textStyle: {
            color: '#CEE2FF'
          },
          itemHeight: 10,
          right: 0
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: xData,
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: ['#074671']
            }
          },
          axisLabel: {
            color: '#D1F3FF',
            fontSize: 10
          }
        },
        yAxis: [
          {
            type: 'value',
            name: this.$t('单位:次'),
            nameTextStyle: {
              color: '#D1F3FF',
              align: 'center'
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
                color: ['#074671']
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#D1F3FF',
              fontSize: 10
            }
          },
          {
            type: 'value',
            min: 0,
            max: 100,
            interval: 20,
            name: this.$t('单位:%'),
            nameTextStyle: {
              color: '#D1F3FF',
              align: 'left'
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dotted',
                color: ['#074671']
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              formatter: '{value} %',
              color: '#D1F3FF',
              fontSize: 10
            }
          }
        ],
        series: [
          {
            name: this.$t('实际巡检'),
            type: 'bar',
            barMaxWidth: 14,
            data: y1,
            smooth: true,
            symbol: "none",
            animationDelay: (0 * 200) - 100,
            animationDuration: 300
          },
          {
            name: this.$t('实际保养'),
            type: 'bar',
            barMaxWidth: 14,
            barGap: "10%",
            data: y2,
            smooth: true,
            symbol: "none",
            animationDelay: (0 * 200) - 100,
            animationDuration: 300
          },
          {
            name: this.$t('综合完结率(%)'),
            type: 'line',
            yAxisIndex: 1,
            symbol: 'circle',
            animationDelay: 1000,
            stack: 'Total',
            smooth: true,
            animationDuration: 300,
            data: y3
          }
        ]
      }
      
      this.initChart(option)
    },
    initChart(option) {
      this.disposeChart()
      
      if (!this.$refs.chartRef) return
      
      this.chart = echarts.init(this.$refs.chartRef)
      this.chart.setOption(option)
      
      window.addEventListener('resize', this.handleResize)
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    },
    disposeChart() {
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
        window.removeEventListener('resize', this.handleResize)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.inspection-maintenance-completed {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: rgba(0, 48, 111, 0.2);
  border: 1px solid rgba(0, 170, 255, 0.2);
  border-radius: 8px;
  overflow: hidden;
}

.completed-header {
  padding: 15px;
  border-bottom: 1px solid rgba(0, 170, 255, 0.2);
  background: linear-gradient(135deg, rgba(1, 32, 67, 0.8) 0%, rgba(0, 48, 111, 0.6) 100%);
}

.header-title {
  color: #b6deff;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
}

.chart-container {
  flex: 1;
  padding: 15px;
}

.chart {
  width: 100%;
  height: 100%;
}

@media (max-width: 1600px) {
  .completed-header {
    padding: 12px;
  }
  
  .header-title {
    font-size: 14px;
  }
  
  .chart-container {
    padding: 12px;
  }
}

@media (max-width: 1200px) {
  .completed-header {
    padding: 10px;
  }
  
  .header-title {
    font-size: 13px;
  }
  
  .chart-container {
    padding: 10px;
  }
}
</style>